module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Black-Alphabetic.f9f82feb.woff";